import { Avatar, Grid, Typography, styled } from '@mui/material';
import { IconButton, TextField, Button } from '@totalsoft/rocket-ui';

export const QuotationDetailContainer = styled(Grid, { shouldForwardProp: prop => prop !== 'inEdit' })(({ theme, inEdit }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  transition: 'transform 150ms ease',
  ...(inEdit && { transform: 'translateX(calc(-100% - 1rem))' })
}));

export const QuotationDetailAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(2.25),
  height: theme.spacing(2.25),
  backgroundColor: theme.palette.warning.main,
  fontSize: '0.7rem !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const QuotationDetailTextField = styled(TextField)(() => ({
  flexShrink: 0,
  zIndex: -10
}));

export const QuotationDetailSaveButton = styled(IconButton)(({ theme }) => ({
  paddingBottom: theme.spacing(1)
}));

export const QuotationInsurerContainer = styled(Grid)(() => ({
  flexWrap: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const QuotationCreatedByContainer = styled(Grid)(() => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}));

export const QuotationText = styled(Typography)(() => ({
  whiteSpace: 'nowrap'
}));

export const QuotationButton = styled(Button, {
  shouldForwardProp: prop => !['quotationSelected'].includes(prop)
})(({ theme, quotationSelected }) => ({
  '&.Mui-disabled': {
    backgroundColor: quotationSelected ? theme.palette.secondary.main : theme.palette.primary.main,
    color: theme.palette.common.white,
    opacity: 0.7
  }
}));
